import script from "./webPc.vue?vue&type=script&setup=true&lang=js"
export * from "./webPc.vue?vue&type=script&setup=true&lang=js"

import "./webPc.vue?vue&type=style&index=0&id=9e55ffb2&lang=scss&scoped=true"
import "./webPc.vue?vue&type=style&index=1&id=9e55ffb2&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\项目\\公司\\cloudeffective-official-website-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e55ffb2"]])

export default __exports__